import { ChartPanel, LineChart } from "@/components/analytics";
import { KpiReadout } from "@/components/ui/kpi-readout";

interface RocPrCalibrationData {
  roc: { auc: number; fpr: number[]; tpr: number[] };
  pr: { auc: number; recall: number[]; precision: number[] };
  calibration: { observed: number[]; predicted: number[] };
}

interface RocPrCalibrationVizProps {
  data: RocPrCalibrationData;
}

export function RocPrCalibrationViz({ data }: RocPrCalibrationVizProps) {
  if (!data?.roc || !data?.pr || !data?.calibration) {
    return <p className="text-xs text-muted">No ROC/PR/calibration data available.</p>;
  }

  const rocPoints = data.roc.fpr.map((fpr, i) => ({ fpr, tpr: data.roc.tpr[i] }));
  const prPoints = data.pr.recall.map((recall, i) => ({ recall, precision: data.pr.precision[i] }));
  const calibrationPoints = data.calibration.predicted.map((predicted, i) => ({
    predicted,
    observed: data.calibration.observed[i],
  }));

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 gap-4">
        <KpiReadout label="ROC AUC" value={data.roc.auc.toFixed(3)} accent />
        <KpiReadout label="PR AUC" value={data.pr.auc.toFixed(3)} />
      </div>

      <div className="grid grid-cols-3 gap-4">
        <ChartPanel title="ROC Curve">
          <LineChart
            data={rocPoints}
            xKey="fpr"
            series={[{ dataKey: "tpr", color: "accent" }]}
            height={300}
          />
        </ChartPanel>

        <ChartPanel title="Precision-Recall">
          <LineChart
            data={prPoints}
            xKey="recall"
            series={[{ dataKey: "precision", color: "accent" }]}
            height={300}
          />
        </ChartPanel>

        <ChartPanel title="Calibration">
          <LineChart
            data={calibrationPoints}
            xKey="predicted"
            series={[{ dataKey: "observed", color: "accent" }]}
            height={300}
          />
        </ChartPanel>
      </div>
    </div>
  );
}
